import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_MissingBotResponse } from '../../../../../constants/APIs';
import queryString from 'query-string';
export default class MissingResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      missingCode: '',
    };
  }
  componentDidMount() {
    console.log(this.props.location);
    const values = this.props.location.pathname.replace(
      '/app/pages/propinfo/missing-response/',
      ''
    );
    // if (values.code !== undefined) {
    //   localStorage.setItem('missingcode', values.code);
    //   this.setState({ missingCode: values.code });
    // } else {
    //   const code = localStorage.getItem('missingcode');
    //   //localStorage.removeItem('missingcode');
    //   if (code !== undefined) {
    this.setState({ missingCode: values });
    //}
    // }
  }
  render() {
    console.log('this.state.missingCode', this.state.missingCode);
    return (
      <Fragment>
        <Card>
          <CardBody>
            {this.state.missingCode !== '' && (
              <ResponseBlockGenerator
                getUrl={gAPI_MissingBotResponse}
                missingCode={this.state.missingCode}
              />
            )}
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
